module.exports = __webpack_public_path__ + "img/device.a4f3702d.png";